import { IntervalUnit } from "../../query/visual/types/interval";
import { ScheduleType } from "../../sync/scheduler/schedule-types";

/**
 * The schedule an envelope with no explicit schedule compiles to. Comparing a
 * pre-serialize document against a post-serialize one requires materializing
 * it, or every unscheduled journey reads as a diff.
 */
export const DEFAULT_ENVELOPE_SCHEDULE = {
  type: ScheduleType.Interval,
  schedule: { interval: { unit: IntervalUnit.Hour, quantity: 1 } },
} as const;

export const isEdgeShaped = (edge: unknown): edge is Record<string, unknown> =>
  typeof edge === "object" &&
  edge !== null &&
  !Array.isArray(edge) &&
  typeof (edge as Record<string, unknown>).from_node_id === "string" &&
  typeof (edge as Record<string, unknown>).to_node_id === "string";
